export enum NodeOperations {
  AddNode = 1,
  RemoveNode = 2,
  AddChildNode = 3,
  AddChildNodeAtIndex = 4,
  DetachChildNode = 5,
  AddIndependentRoot = 6,
  RemoveIndependentRoot = 7,
}
